// extracted by mini-css-extract-plugin
export default {"root":"IconTicket_root__k3yCI"};